import { createThunkRoutine } from 'redux-thunk-routine';
import {
  GET_ROLES,
  GET_APPLICATION_ROLES,
  CREATE_ROLE,
  DELETE_ROLE,
  UPDATE_ROLE,
  ASSIGN_ROLE,
  UN_ASSIGN_ROLE,
} from '~modules/Auth/action-types';
import { IApplicationRole, IRolesData } from './interfaces';

export const GetRolesRoutine = createThunkRoutine<IRolesData>(GET_ROLES);
export const GetApplicationRolesRoutine = createThunkRoutine<IApplicationRole[]>(GET_APPLICATION_ROLES);

export const CreateRoleRoutine = createThunkRoutine<void>(CREATE_ROLE);
export const DeleteRoleRoutine = createThunkRoutine<void>(DELETE_ROLE);
export const UpdateRoleRoutine = createThunkRoutine<void>(UPDATE_ROLE);

export const AssignRoleRoutine = createThunkRoutine<void>(ASSIGN_ROLE);
export const UnAssignRoleRoutine = createThunkRoutine<void>(UN_ASSIGN_ROLE);
